import { get, post } from "@/modules/request";
import {
  CoinBalanceRecordEntityType,
  CoinExpenditure,
  CoinIncome,
  CoinQuest,
  CoinQuestTaskType,
  CoinQuestUser,
  CoinVote,
} from "@/types/coin";
import {
  CursorPageRequest,
  CursorPageResponse,
  ItemResponse,
  WriteResponse,
} from "@/types/api-types";

/** 查询全部获取硬币的方式 */
export async function readAllCoinQuest(): Promise<ItemResponse<CoinQuest>> {
  return get("/CoinQuest/ReadAll");
}

/** 查询今日硬币获取记录 */
export async function readAllCoinQuestUser(): Promise<
  ItemResponse<CoinQuestUser>
> {
  return get("/CoinQuestUser/ReadAll");
}

/** 签到 */
export async function createOneCoinQuestUser(
  coinQuestId: CoinQuestTaskType
): Promise<WriteResponse<CoinQuestUser>> {
  return post(`/CoinQuestUser/CreateOne/0`, { coinQuestId });
}

/** 查询硬币支出记录 */
export async function readCoinExpenditurePage(
  request: CursorPageRequest<void>
): Promise<CursorPageResponse<CoinExpenditure>> {
  return get("/CoinExpenditure/ReadPage", request);
}

/** 查询硬币收入记录 */
export async function readCoinIncomePage(
  request: CursorPageRequest<void>
): Promise<CursorPageResponse<CoinIncome>> {
  return get("/CoinIncome/ReadPage", request);
}

/** 投票 */
export async function createOneCoinVote(params: {
  amount: number;
  entityType: CoinBalanceRecordEntityType;
  entityId: number;
  text?: string;
  isAnonymous: 0 | 1;
  isGolden?: 0 | 1;
}): Promise<WriteResponse<CoinVote>> {
  return post(`/CoinVote/CreateOne/0`, params);
}
